// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class HashTable {
    constructor() {
        this.table = new Array(127);
        this.counter = 0;
    }
    _hash(key) {
        let hash = 0;
        for (let i = 0; i < key.length; i++) {
            hash += key.charCodeAt(i);
        }
        return hash % this.table.length;
    }
    Set(key, value) {
        const index = this._hash(key);
        if (this.table[index]) {
            for (let i = 0; i < this.table[index].length; i++) {
                if (this.table[index][i] != null && this.table[index][i][0] === key) {
                    this.table[index][i][1] = value;
                    return;
                }
            }
            this.table[index].push([key, value]);
        }
        else {
            this.table[index] = [];
            this.table[index].push([key, value]);
        }
        this.counter++;
    }
    Get(key) {
        const index = this._hash(key);
        if (this.table[index] != null && this.table.length > 0) {
            for (let i = 0; i < this.table.length; i++) {
                if (this.table[index][i] != null && this.table[index][i][0] === key) {
                    return this.table[index][i][1];
                }
            }
        }
        return undefined;
    }
    Clear(key) {
        const index = this._hash(key);
        if (this.table[index] != null && this.table[index].length > 0) {
            for (let i = 0; i < this.table.length; i++) {
                if (this.table[index][i][0] === key) {
                    this.table[index].splice(i, 1);
                    this.counter--;
                    return true;
                }
            }
        }
        else {
            return false;
        }
    }
    Display() {
        this.table.forEach((values, index) => {
            const chainedValues = values.map(([key, value]) => `[ ${key}: ${value} ]`);
            console.log(`${index}: ${chainedValues}`);
        });
    }
}
